import React, { useState, useEffect } from 'react';
import { doc, setDoc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../../../firebase';
import './peferenceSetting.css';

const PreferenceSetting = () => {
  const user = auth.currentUser;
  const [isShortTimestamps, setIsShortTimestamps] = useState(false);

  useEffect(() => {
    if (!user) return;
    return onSnapshot(doc(db, 'users', user.uid, 'valueSettings', 'timestamps'), snap => {
      setIsShortTimestamps(!!snap.data()?.isShortTimestamps);
    }, () => {});
  }, [user]);

  const handleLengthOption = async (value) => {
    const isShort = value === 'short';
    if (isShort === isShortTimestamps) return;
    setIsShortTimestamps(isShort);
    try {
      await setDoc(doc(db, 'users', user.uid, 'valueSettings', 'timestamps'), { isShortTimestamps: isShort }, { merge: true });
    } catch (error) {
      console.error(error);
      setIsShortTimestamps(!isShort);
    }
  };

  return (
    <>
      {/* Header outside the container */}
      <div className="setting-header">AI Preferences</div>
      
      {/* Main container for AI Preferences */}
      <div className="account-settings-container">
        <div className="settings-row">
          <div className="settings-label">
            <span>Timestamp Length</span>
            <div className="settings-subtitle">
            Short timestamps offer a concise overview for lengthy content.
            </div>
          </div>
          <div className="settings-field set-segmented" role="group" aria-label="Timestamp length">
            <button
              value="short"
              className={`timestamp-button short ${isShortTimestamps ? 'selected' : ''}`}
              onClick={() => handleLengthOption('short')}
            >
              Short
            </button>
            <button
              value="standard"
              className={`timestamp-button standard ${!isShortTimestamps ? 'selected' : ''}`}
              onClick={() => handleLengthOption('standard')}
            >
              Standard
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreferenceSetting;
